module.exports = __webpack_public_path__ + "static/media/play-store.07312979.png";